import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Video } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

export const PropertyVideoSection = () => {
  return (
    <Card className="p-6">
      <div className="space-y-4">
        <div>
          <h3 className="text-lg font-semibold">Property Video (Optional)</h3>
          <p className="text-sm text-muted-foreground">
            Add a video tour to showcase your property
          </p>
        </div>

        <Separator />

        <Alert>
          <Video className="h-4 w-4" />
          <AlertDescription>
            <strong>Video upload available after saving!</strong>
            <br />
            Once your property listing is created, you can add a video tour
            from the Edit Property page. Videos help buyers visualize the
            property and increase engagement.
          </AlertDescription>
        </Alert>
      </div>
    </Card>
  );
};
